import {Component, Input} from '@angular/core';
import {TaskService} from '../../services/task.service';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {ReportService} from '../../services/report.service';
import {ReportTaskDTO} from '../../model/reportTaskDTO';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent {

  @Input() clientId: number;
  @Input() task:  ReportTaskDTO;

  constructor(private service: TaskService,
              private router: Router,
              public reportService: ReportService) {
  }

  inThePast(date) {
    return moment(date, 'DD-MM-YYYY').toDate() <= new Date();
  }

  click() {
    this.router.navigate(this.reportService.getReportUrl(this.task.clientId, this.task.reportType, this.task.year));
  }
}
